
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/olympics",
      function () {
        return require("private-next-pages/olympics/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/olympics"])
      });
    }
  